import { importAssetsFromExcel } from '@/providers/assetsProvider';
import { importThreatsFromExcel } from '@/providers/threatsProvider';
import { excelImportVulnerabilities } from '@/providers/vulnerabilitiesProvider';
import { showAlert, showLoader, showValidationListAlert } from './sweetAlert';
import { useAuthStore } from '@/stores/authStore';

const importProviders = {
    assets: importAssetsFromExcel,
    threats: importThreatsFromExcel,
    vulnerabilities: excelImportVulnerabilities
};

export function getProperty(input, path) {

    try {

        const parsed = typeof input === 'string' ? JSON.parse(input) : input;

        if (!path.includes('.')) {
            return parsed?.[path] ?? '';
        }

        return path.split('.').reduce((acc, key) => acc?.[key], parsed) ?? '';

    } catch {

        return '';

    }
}

export function mapJSON (obj, key, lang = 'es') {

    return obj ? getProperty(obj[key], lang) : null

}

export function mapIdName (obj, key = 'name') {

    return obj ? { id: obj.id, name: mapJSON(obj, key) } : { id: null, name: null }

}

export function validateTenant(authStore) {

    return authStore.subdomain !== 'app'

}

export async function importExcelUtil(event, translate, type, onValidationError = null) {

    try {

        showLoader(translate('labels.loadingLabel'));

        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);

        const { data } = await importProviders[type](formData);

        showAlert({
            message: data.message,
            icon: 'success',
            title: translate('labels.success')
        }).then(() => {

            location.reload();
        });

    } catch (error) {

        checkCatch(error, translate);

        const { data, status } = error.response;

        if (status === 422 && !data.errors) {

            if (onValidationError) {

                onValidationError(data.data, data.message);
                return;

            }

        }
    }
}

export function checkCatch(error, translate) {

    let data = {}, status = 0, dataErrors = [];

    if (error.response) {

        ({ data, status } = error.response);

        if (status === 403) {

            data.message = translate('labels.permissionDenied');

        }

        if (status === 422 && data.errors) {

            Object.entries(data.errors).forEach(([key, value]) => {

                dataErrors += `<li>- ${value[0]}</li>`;

            });

        }

    }

    if (status != 401) {

        showValidationListAlert({
            title: data.title,
            icon: data.icon,
            message: data.message,
            data: dataErrors
        });
    }
}

export async function sleep(ms) {

    return new Promise(function(resolve) {

        setTimeout(resolve, ms);

    });
}

export async function getAccessToken() {

    const authStore = useAuthStore();

    if (!authStore.accessToken) {

        try {

			await authStore.fetchClientToken();

        } catch (error) {

            console.error('Error al obtener el token de cliente:', error);
            return;
        }
    }

    return authStore.accessToken || authStore.clientAccessToken;

}

export function goBack(router) {

    if (window.history.length > 1) {

        router.go(-1);

    } else {

        router.push({ name: 'HomePage' });

    }

}

export function isMSPIRoute(route) {

    if (route.name?.toString().toLowerCase().includes('mspi')) {
        return true;
    }

    if (route.path?.toLowerCase().includes('mspi')) {
        return true;
    }

    if (route.meta?.requiresMSPI) {
        return true;
    }

    return false;
}
